import React, { useState, useEffect, useRef } from "react";
import { Card, Button, Typography, Space, Alert } from "antd";

const { Title, Text } = Typography;

export default function TurnstileGate({ onSuccess }) {
  const [error, setError] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const turnstileRef = useRef(null);
  const widgetIdRef = useRef(null);

  // Your Cloudflare Turnstile site key (replace with your actual key)
  const SITE_KEY = process.env.REACT_APP_CLOUDFARE_SITE_KEY; // Demo key - replace with yours

  useEffect(() => {
    // Load Turnstile script
    const script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
    script.async = true;
    script.defer = true;
    script.onload = () => {
      // Render Turnstile widget once script is loaded
      if (window.turnstile && turnstileRef.current) {
        widgetIdRef.current = window.turnstile.render(turnstileRef.current, {
          sitekey: SITE_KEY,
          theme:"light",
          callback: handleTurnstileSuccess,
          "error-callback": handleTurnstileError,
        });
      }
    };
    document.head.appendChild(script);

    return () => {
      // Cleanup
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
      if (window.turnstile && widgetIdRef.current) {
        window.turnstile.remove(widgetIdRef.current);
      }
    };
  }, []);


  const handleTurnstileSuccess = (token) => {
    console.log("Turnstile token received:", token);
    setIsVerifying(true);
    setError("");

    // Here you would normally send the token to your backend for verification
    // For demo purposes, we'll simulate a backend call
    verifyTokenOnBackend(token);
  };

  const handleTurnstileError = () => {
    setError("Verification failed. Please try again.");
    setIsVerifying(false);
  };

  const verifyTokenOnBackend = async (token) => {
    try {
      // Replace this with your actual backend API call
      // Example:
      const response = await fetch(process.env.REACT_APP_CLOUDFARE_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token })
      });
      const data = await response.json();

      // Simulating backend verification
      setTimeout(() => {
        // In production, check response from your backend
        if (data.success) {
         onSuccess();
        } else {
          setError("Verification failed. Please try again.");
          setIsVerifying(false);
          window.turnstile?.reset(widgetIdRef.current);
        }
      }, 1000);
    } catch (err) {
      setError("Verification error. Please try again.");
      setIsVerifying(false);
      if (window.turnstile && widgetIdRef.current) {
        window.turnstile.reset(widgetIdRef.current);
      }
    }
  };

  const handleManualRefresh = () => {
    if (window.turnstile && widgetIdRef.current) {
      window.turnstile.reset(widgetIdRef.current);
    }
    setError("");
    setIsVerifying(false);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f6fa",
      }}
    >
      <Card
        style={{
          maxWidth: 450,
          width: "100%",
          textAlign: "center",
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <Title level={3}>Security Verification</Title>
        <Text type="secondary">
          Please verify you're human to continue
        </Text>

        <div style={{ margin: "2rem 0", minHeight: "65px" }}>
          <div ref={turnstileRef}></div>
        </div>

        {/* {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            style={{ marginBottom: "1rem" }}
          />
        )} */}

        <Space style={{ marginTop: "1rem" }}>
          <Button onClick={handleManualRefresh} disabled={isVerifying}>
            Reset
          </Button>
        </Space>


      </Card>
    </div>
  );
}